export { default as useFileAttachmentDimensions } from './useFileAttachmentDimensions';
